import { apiSlice } from "../../app/api/apiSlice"

export const NGApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getRobot: builder.query<any[], string>({
            query: (date) => ({
                url: `/Robot/GetRobot?date=${date}`,
                responseHandler: 'json'
            })
        }),

        putRobot: builder.mutation({
            query: (body) => ({
                url: `/Robot/PutRobot/${body.id}`,
                method: 'PUT',
                responseHandler: 'json',
                body: {
                    ...body
                }
            })
        }),
    })
})

export const {
    useLazyGetRobotQuery,
    usePutRobotMutation,
} = NGApiSlice 